// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JPBc","label":"styles_label__3Rbwy"};